import * as React from 'react';
import { ChartFactory, TChartFactoryProps } from '@cian/react-chartjs-component';
import * as styles from './styles.css';

interface ISalesChartProps {
  chartCfg: TChartFactoryProps;
}

export function SalesChart({ chartCfg }: ISalesChartProps) {
  return (
    <div className={styles['graph']}>
      <ChartFactory {...chartCfg} />
    </div>
  );
}
